import { render, staticRenderFns } from "./PaymentInvoice.vue?vue&type=template&id=45de11a4&scoped=true"
import script from "./PaymentInvoice.vue?vue&type=script&lang=js"
export * from "./PaymentInvoice.vue?vue&type=script&lang=js"
import style0 from "./PaymentInvoice.vue?vue&type=style&index=0&id=45de11a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45de11a4",
  null
  
)

export default component.exports